import { render, staticRenderFns } from "./advisor-comment-with-entry.vue?vue&type=template&id=99e4f10a"
import script from "./advisor-comment-with-entry.vue?vue&type=script&lang=js"
export * from "./advisor-comment-with-entry.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports